export default function Pricing() {
  const benefits = [
    { text: 'No Hidden Fees', icon: 'ri-shield-check-line' },
    { text: 'Unbiased Advice', icon: 'ri-user-heart-line' },
    { text: 'Cancel Anytime', icon: 'ri-close-circle-line' },
    { text: 'Contractor Vetting', icon: 'ri-search-eye-line' },
    { text: 'All Bids Included', icon: 'ri-file-list-3-line' },
    { text: 'Post-Job Support', icon: 'ri-customer-service-2-line' }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="bg-emerald-900 py-24">
      <div className="max-w-5xl mx-auto px-6">
        {/* Pricing Card */}
        <div className="bg-white rounded-3xl shadow-2xl p-12 md:p-16">
          {/* Badge */}
          <div className="text-center mb-6">
            <span className="inline-block bg-orange-100 text-orange-600 text-xs font-bold uppercase tracking-wider px-4 py-2 rounded-full">
              Simple, Transparent Pricing
            </span>
          </div>

          {/* Main Price */}
          <div className="text-center mb-8">
            <p className="text-7xl md:text-8xl font-bold text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>
              $500
            </p>
            <p className="text-xl text-gray-600 mt-3">Flat Fee - Pay Once</p>
            <p className="text-sm text-emerald-700 font-semibold mt-2">
              Most clients save significantly more than our fee.
            </p>
          </div>

          {/* Divider */}
          <div className="w-3/5 h-px bg-gray-300 mx-auto my-10"></div>

          {/* Savings Formula */}
          <div className="text-center mb-10">
            <p className="text-lg font-semibold text-gray-800 mb-4">PLUS: Success Fee Structure</p>
            <div className="flex flex-wrap items-center justify-center gap-3 text-base text-gray-700">
              <span className="font-medium">Lesser of</span>
              <div className="bg-emerald-100 border-2 border-emerald-600 px-4 py-2 rounded-lg font-bold text-emerald-800">
                5% of job
              </div>
              <span className="font-medium">OR</span>
              <div className="bg-orange-100 border-2 border-orange-600 px-4 py-2 rounded-lg font-bold text-orange-800">
                25% of savings
              </div>
            </div>
            <p className="text-sm text-gray-500 mt-4 italic">
              You only pay more when we save you money
            </p>
          </div>

          {/* Benefits Grid */}
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-4 mb-10">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-center gap-3">
                <i className={`${benefit.icon} text-2xl text-emerald-600`}></i>
                <span className="text-base text-gray-700 font-medium">{benefit.text}</span>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <button 
            onClick={scrollToContact}
            className="w-full bg-orange-500 hover:bg-orange-600 text-white py-4 rounded-2xl font-bold text-base transition-all shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer"
          >
            Schedule Your Roof Assessment
          </button>
        </div>
      </div>
    </section>
  );
}